import React from 'react';
import { Modal, View, TouchableOpacity, TouchableHighlight, StyleSheet, Platform } from 'react-native';
import { MainColors } from '../../constants/Colors';
import { useMediaQuery } from "react-responsive";

const ModalWrapper = (props) => {

    const isDesktop = useMediaQuery({
        query: "(min-width: 1200px)",
    });

    return (
        <Modal animationType="fade" transparent={true} visible={props.visible}>
            <TouchableOpacity style={styles.modalBackground} onPress={props.onModalBackgroundPressed}>
                <TouchableHighlight style={isDesktop ? styles.desktopModalContainer : styles.modalContainer}>
                    <View>
                        {props.children}
                    </View>
                </TouchableHighlight>
            </TouchableOpacity>
        </Modal>
    )
}

const styles = StyleSheet.create({
    modalBackground: {
        flex: 1,
        justifyContent: 'center',
        backgroundColor: MainColors.dimmedBackground
    },
    modalContainer: {
        marginHorizontal: 30,
        paddingVertical: 20,
        backgroundColor: "white",
        borderRadius: 8,
    },
    desktopModalContainer: {
        marginHorizontal: 30,
        paddingVertical: 20,
        backgroundColor: "white",
        borderRadius: 8,
        width: '50%',
        alignSelf: 'center'
    }
});

export default ModalWrapper;